import builder from "@rsql/builder";
import { ExpressionNode } from '@rsql/ast';


export default {
  ...builder,

  customAttributeContains(selector: string, value: string): ExpressionNode {
    return builder.and(
      builder.eq('customAttributes.name', selector),
      builder.eq('customAttributes.value', `*${value}*`)
    );
  },

  // attributeContains(selector: string, value: string): ComparisonNode {
  //   return builder.comparison(`attributes.name[${selector}].value`, '=elem=', `.*${value}.*`);
  // },


  // like(selector: string, value: string): ComparisonNode {
  //   return builder.comparison(selector, '=regex=', value);
  // }

}